// extracted by mini-css-extract-plugin
export default {"start":"SearchForm_start__vpYwW","search":"SearchForm_search__QF9sf","button":"SearchForm_button__V9pjm","input":"SearchForm_input__EfNAo"};